import { getCurrentBranch, getToken, getUser, removeCurrentBranch as removeCurrentBranchRepo, removeSession, setCurrentBranch as setCurrentBranchRepo, setSession as persistSession, updateUser } from "helpers/auth-helper"
import { useEffect } from "react"
import { useState, useContext, createContext } from "react"

// Initial state
const initialState = {
    user: getUser(),
    token: getToken(),
    currentBranch: getCurrentBranch(),
    setSession: (token, user) => {
        persistSession(token, user)
    },
    setCurrentBranch: (branch) => {
        setCurrentBranchRepo(JSON.stringify(branch))
    },
    removeCurrentBranch: () => {
        removeCurrentBranchRepo()
    },
    logout: () => {
        removeSession()
    },
    can: (node) => {
        const user = getUser()
        const currentBranch = getCurrentBranch()

        if (!user?.roles?.length) {
            return false
        } else {
            if (currentBranch) {
                var permissions = []
                currentBranch.roles.map((role) => {
                    role.permissions.map((permission) => {
                        permissions.push(permission)
                    })
                })

                return (currentBranch.roles.find((role) => role.is_super === 1) ? true : permissions.find(row => row.node === node)) ? true : false
            } else {
                return user.roles.find((role) => role.is_super === 1) ? true : false
            }
        }
    },
    isSuper: () => {
        const user = getUser()
        const currentBranch = getCurrentBranch()

        if (!user?.roles?.length) {
            return false
        } else {
            if (currentBranch) {
                return currentBranch.roles.find((role) => role.is_super === 1) ? true : false
            } else {
                return user.roles.find((role) => role.is_super === 1) ? true : false
            }
        }
    }
}

// Auth context
export const AuthContext = createContext(initialState)

// Provider
export const AuthProvider = ({ children }) => {
    const [user, setUserState] = useState(getUser())
    const [token, setTokenState] = useState(getToken())
    const [currentBranch, setCurrentBranchState] = useState(getCurrentBranch())

    const setSession = (token, user) => {
        setUserState(user)
        setTokenState(token)
        persistSession(token, user)
    }

    const setCurrentBranch = (branch) => {
        setCurrentBranchState(branch)
        setCurrentBranchRepo(JSON.stringify(branch))
    }

    const removeCurrentBranch = () => {
        setCurrentBranchState(null)
        removeCurrentBranchRepo()
    }

    const logout = () => {
        removeSession()
    }

    const can = (node) => {
        if (!user?.roles?.length) {
            return false
        } else {
            if (currentBranch) {
                var permissions = []
                currentBranch.roles.map((role) => {
                    role.permissions.map((permission) => {
                        permissions.push(permission)
                    })
                })

                return (currentBranch.roles.find((role) => role.is_super === 1) ? true : permissions.find(row => row.node === node)) ? true : false
            } else {
                return user.roles.find((role) => role.is_super === 1) ? true : false
            }
        }
    }

    const isSuper = () => {
        if (!user?.roles?.length) {
            return false
        } else {
            if (currentBranch) {
                return currentBranch.roles.find((role) => role.is_super === 1) ? true : false
            } else {
                return user.roles.find((role) => role.is_super === 1) ? true : false
            }
        }
    }

    // ATALLA-403: boleh memilih semua outlet ENTITAS-nya di filter outlet (super
    // otomatis boleh; selain itu via node permission 'outlet.filter-entity').
    const canFilterAllOutlets = () => {
        return isSuper() || can('outlet.filter-entity')
    }

    const value = {
        user,
        token,
        currentBranch,
        setSession,
        setCurrentBranch,
        removeCurrentBranch,
        logout,
        can,
        isSuper,
        canFilterAllOutlets
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    return useContext(AuthContext)
}